import { render, staticRenderFns } from "./SensorSetup.vue?vue&type=template&id=97be514e&scoped=true&"
import script from "./SensorSetup.vue?vue&type=script&lang=js&"
export * from "./SensorSetup.vue?vue&type=script&lang=js&"
import style0 from "./SensorSetup.vue?vue&type=style&index=0&id=97be514e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be514e",
  null
  
)

export default component.exports